//review slider//
$(document).ready(function(){
  $('.slider3').slick({
    arrow: false,
    infinite: true,
    autoplay: true,
    dots: false,
    autoplaySpeed: 4000,
    speed: 300,
    slidesToShow: 1,
    arrows: true,
    prevArrow: '<div class="slick-prev"><i class="fas fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fas fa-angle-right" aria-hidden="true"></i></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

//Ingredento componnet//
$(document).ready(function(){
  $('.ingcomp .slider2').slick({
    arrow: true,
    infinite: true,
    autoplay: true,
    dots: false,
    autoplaySpeed: 3000,
    speed: 300,
    slidesToShow: 2,
    arrows: true,
    prevArrow: '<div class="slick-prev"><i class="fas fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fas fa-angle-right" aria-hidden="true"></i></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});